import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { GetUserDetail_extensionGroupsConnection } from '../../user-details/queries/generated/GetUserDetail';
import { RoleDetailSaveEvent } from '../models/role-detail-form-submit-event';
import { GetPrivileges_privilegesConnection_items } from '../queries/generated/GetPrivileges';
import { GetRoleDetail_extensionsConnection, GetRoleDetail_role } from '../queries/generated/GetRoleDetail';
import { SaveRole } from '../queries/generated/SaveRole';

export const roleDetailLoad = createAction('[Role Detail] Load');

export const roleDetailCancel = createAction('[Role Detail] Cancel');

export const roleDetailAccessDenied = createAction('[Role Detail] Access Denied');

export const loadRoleDetailsSuccess = createAction(
   '[API] Load Role Success',
   props<{
      data: GetRoleDetail_role;
      extensions: GetRoleDetail_extensionsConnection;
      extensionGroups: GetUserDetail_extensionGroupsConnection;
   }>()
);

export const loadSystemRoleDetailsSuccess = createAction(
   '[API] Load System Role Success',
   props<{
      data: GetRoleDetail_role;
      extensions: GetRoleDetail_extensionsConnection;
      extensionGroups: GetUserDetail_extensionGroupsConnection;
   }>()
);

export const loadRoleDetailsFailure = createAction('[API] Load Role Failure', props<SingleGraphError>());

export const saveRoleDetail = createAction('[Role Detail] Save', props<RoleDetailSaveEvent>());

export const saveRoleDetailSuccess = createAction('[Role Detail] Save Success', props<{ data: SaveRole }>());

export const saveRoleDetailSuccessForNotify = createAction('[Role Detail] Save Success For Notify');

export const saveRoleDetailFailure = createAction('[Role Detail] Save Failure', props<SingleGraphError>());

export const deleteRole = createAction('[Role Detail] Delete Role', props<{ roleId: number; name: string }>());

export const deleteRoleSuccess = createAction('[Role Detail] Delete Role Success', props<{ name: string, isOnSystemPage: boolean }>());

export const deleteRoleFailure = createAction('[Role Detail] Delete Role Failure', props<SingleGraphError>());

export const privilegesLoad = createAction('[Role Detail] Load Privileges');

export const privilegesLoadSuccess = createAction(
   '[API] Load Privileges Success',
   props<{ data: GetPrivileges_privilegesConnection_items[] }>()
);

export const privilegesLoadFailure = createAction('[API] Load Privileges Failure', props<SingleGraphError>());

export const roleRouteCorrected = createAction('[Role Detail] Route Corrected');
